class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.isPlaying = false;
  }

  connectedCallback() {
    this.duration = parseInt(this.dataset.duration) || 90;
    this.initTimer();
    this.updateTimer();
    
    if (this.dataset.autoplay === 'true') {
      this.playTimer();
    }
  }

  disconnectedCallback() {
    this.pauseTimer();
  }
  
  initTimer() {
    this.innerHTML = '';
    this.minutesSpan = document.createElement('span');
    let separator = document.createTextNode(':');
    this.secondsSpan = document.createElement('span');
    this.append(this.minutesSpan, separator, this.secondsSpan);
  }
  
  updateTimer() {
    let timeLeft = parseInt(this.dataset.duration) || 0;
    
    if (timeLeft <= 0) {
      this.pauseTimer();
      this.minutesSpan.innerHTML = '00';
      this.secondsSpan.innerHTML = '00';
      return;
    }
    
    let minutes = Math.floor(timeLeft / 60);
    let seconds = timeLeft % 60;
    
    this.minutesSpan.innerHTML = this.formatNumber(minutes);
    this.secondsSpan.innerHTML = this.formatNumber(seconds);
    this.dataset.duration = timeLeft - 1;
  }
  
  playTimer() {
    if (!this.isPlaying) {
      this.isPlaying = true;
      this.playInterval = setInterval(() => {
        this.updateTimer();
      }, 1000);
    }
  }
  
  pauseTimer() {
    if (this.playInterval) {
      clearInterval(this.playInterval);
    }
    this.isPlaying = false;
  }
  
  formatNumber(num) {
    return num < 10 ? '0' + num : num.toString();
  }
}

customElements.define('countdown-timer', CountdownTimer);
